import { removeNulls } from 'utils/Object.utils';

type ReducerAction = {
  type?: string;
  [key: string]: any;
};

export type PortfolioListItem = {
  id: string;
  [key: string]: unknown;
};

export type PortfoliosListState = {
  byId?: Record<string, PortfolioListItem>;
  allIds?: string[];
  isLoading?: boolean;
  error?: { code: string; [key: string]: unknown };
  [key: string]: unknown;
};

const initialState: PortfoliosListState = {
  byId: {},
  allIds: [],
};

const portfoliosById = (
  state: Record<string, PortfolioListItem> = initialState.byId,
  action: ReducerAction
): Record<string, PortfolioListItem> => {
  switch (action.type) {
    case 'PORTFOLIOS_LIST_UPDATE': {
      const { portfolio } = action;
      return {
        ...state,
        [portfolio.id]: portfolio,
      };
    }
    case 'PORTFOLIOS_ADD_NEW': {
      const { portfolio: newPortfolio } = action;
      return {
        ...state,
        [newPortfolio.id]: newPortfolio,
      };
    }
    case 'PORTFOLIOS_DELETE': {
      // TODO: Propagate the deletion to remove related items
      const { portfolioId } = action;
      return removeNulls({
        ...state,
        [portfolioId]: null,
      }) as Record<string, PortfolioListItem>;
    }
    default:
      return state;
  }
};

const allPortfolios = (
  state: string[] = initialState.allIds,
  action: ReducerAction
): string[] => {
  switch (action.type) {
    case 'PORTFOLIOS_ADD_NEW': {
      const { portfolio } = action;
      return state.concat([portfolio.id]);
    }
    case 'PORTFOLIOS_DELETE': {
      const { portfolioId } = action;
      return state.filter((id) => {
        return id !== portfolioId;
      });
    }
    default:
      return state;
  }
};

const portfoliosListReducer = (
  state: PortfoliosListState = initialState,
  action: ReducerAction
): PortfoliosListState => {
  switch (action.type) {
    case 'AUTH_LOGOUT':
    case 'AUTH_LOGOUT_SUCCESS': {
      return {};
    }
    case 'PORTFOLIOS_LIST_IS_LOADING': {
      return {
        ...state,
        isLoading: true,
      };
    }
    case 'PORTFOLIOS_LIST_FINISHED_LOADING': {
      return action.payload || initialState;
    }
    case 'PORTFOLIOS_LIST_FINISHED_LOADING_WITH_ERROR': {
      const error = action.payload.error || { code: 'Unknown' };
      return {
        ...initialState,
        error,
        isLoading: false,
      };
    }
    default: {
      return {
        ...state,
        byId: portfoliosById(state.byId, action),
        allIds: allPortfolios(state.allIds, action),
      };
    }
  }
};
export default portfoliosListReducer;
